import api from '../config/api';

// Matches AdminAdvertisementsController — routes under /api/admin/advertisements.
// This project's convention is GET/POST only; mutations are POST with a
// descriptive suffix route (never PUT/PATCH/DELETE).
const advertisementService = {
  async getList({ search, status, platform, type, page = 1, size = 20 } = {}) {
    const params = {};
    if (search) params.search = search;
    if (status !== undefined && status !== null && status !== '') params.status = status;
    if (platform !== undefined && platform !== null && platform !== '') params.platform = platform;
    if (type !== undefined && type !== null && type !== '') params.type = type;
    params.page = page;
    params.size = size;
    const response = await api.get('/api/admin/advertisements', { params });
    return response.data;
  },

  async getSummary() {
    const response = await api.get('/api/admin/advertisements/summary');
    return response.data;
  },

  async getRegistry(platform, type) {
    const response = await api.get('/api/admin/advertisements/registry', { params: { platform, type } });
    return response.data;
  },

  async getDetails(id) {
    const response = await api.get(`/api/admin/advertisements/${id}`);
    return response.data;
  },

  async getAnalytics(id) {
    const response = await api.get(`/api/admin/advertisements/${id}/analytics`);
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/api/admin/advertisements', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.post(`/api/admin/advertisements/${id}/update`, payload);
    return response.data;
  },

  async remove(id) {
    const response = await api.post(`/api/admin/advertisements/${id}/delete`);
    return response.data;
  },

  async activate(id) {
    const response = await api.post(`/api/admin/advertisements/${id}/activate`);
    return response.data;
  },

  async disable(id) {
    const response = await api.post(`/api/admin/advertisements/${id}/disable`);
    return response.data;
  },

  async duplicate(id) {
    const response = await api.post(`/api/admin/advertisements/${id}/duplicate`);
    return response.data;
  },
};

export default advertisementService;
